import { Tabs, Tag } from "antd";
import { useContext, useState } from "react";
import "./module-settings.scss";
import {
  ProjectContext,
  isPermissionNotGrantted
} from "context/ProjectProvider";
import { useHistory, useParams } from "react-router";
import { ProjectPermissionEnum } from "../../../constants";

import MaterialSettings from "./material-settings/material-settings";
import SubmittalSettings from "./submittal-settings/submittal-settings";
import ProjectBidPackageSettings from "./bid-package-settings/project-bid-package-settings";
import DesignScopeSettings from "./design-scope-settings/design-scope-settings";

function ModuleSettings() {
  const {
    tokenContents,
    columnHeaders: { submittalHeaders, materialHeaders, bidPackageHeaders },
    isFeatureFlagEnabled
  } = useContext(ProjectContext);

  const history = useHistory();
  const { projectId, tab2Id } = useParams() as any;
  const isBuyoutEnabled = isFeatureFlagEnabled("BUYOUT");
  // Design Package settings are hidden until Beta feedback. A deep link to
  // that tab falls back to the same default as a missing tab.
  const defaultTab = isBuyoutEnabled ? "design-scope" : "submittals";
  const [tabIndex, setTabIndex] = useState<string>(
    tab2Id && tab2Id !== "design-packages" ? tab2Id : defaultTab
  );

  const tabItems = [
    ...(isBuyoutEnabled
      ? [
          {
            label: (
              <span
                className="flex items-end space-x-1"
                data-testid="design-scope-tab"
              >
                <div> Design Scope</div>
                <Tag>Beta</Tag>
              </span>
            ),
            key: "design-scope",
            children: (
              <DesignScopeSettings
                disabled={isPermissionNotGrantted(
                  ProjectPermissionEnum.EditProjectDetail,
                  tokenContents?.role ?? ""
                )}
              />
            )
          }
        ]
      : []),
    ...(isBuyoutEnabled
      ? [
          {
            label: (
              <span className="flex items-end space-x-1">
                <div> Bid Packages</div>
                <Tag>Beta</Tag>
              </span>
            ),
            key: "bid-packages",
            children: (
              <ProjectBidPackageSettings
                bidPackageHeader={bidPackageHeaders}
                disabled={isPermissionNotGrantted(
                  ProjectPermissionEnum.EditProjectDetail,
                  tokenContents?.role ?? ""
                )}
              />
            )
          }
        ]
      : []),
    {
      label: "Submittals",
      key: "submittals",
      children: (
        <SubmittalSettings
          projectId={projectId}
          submittalheader={submittalHeaders}
          disabled={isPermissionNotGrantted(
            ProjectPermissionEnum.EditProjectDetail,
            tokenContents?.role ?? ""
          )}
        />
      )
    },
    {
      label: "Materials",
      key: "materials",
      children: (
        <MaterialSettings
          materialheader={materialHeaders}
          disabled={isPermissionNotGrantted(
            ProjectPermissionEnum.EditProjectDetail,
            tokenContents?.role ?? ""
          )}
        />
      )
    }
  ];

  return (
    <div className="w-full py-1 h-full module-settings--parentTabs">
      <Tabs
        onChange={(activeKey) => {
          history.push(
            `/project/${projectId}/settings/modules/${activeKey.toString()}`
          );
          setTabIndex(activeKey);
        }}
        activeKey={tabIndex}
        items={tabItems}
        destroyOnHidden
        data-testid="index-tabs-project-module-settings"
      />
    </div>
  );
}
export default ModuleSettings;
